<template>
    <div class="slide-header"
    :style="{
        color: colors.theme == 'dark' ? '#fff' : '#000',
        'border-bottom': colors.theme == 'dark' ? '1px solid #262626' : '1px solid #262626',
    }"
    >
        <div class="slide-index">
            <span class="index">{{index + 1}}/{{maxIndex}}</span>
        </div>
        <div class="slide-title">
            <h1 class="title">{{title}}</h1>
            <div class="index-circle">
                <div class="circle" 
                     :class="calcCircle(index)"
                     v-for="(circle, index) in maxIndex"
                     :key="index"></div> 
            </div>
        </div>
        <div @click="exit()" class="slide-right-option" v-show="rightOption">
            <span class="right-option">{{rightTitle}}</span>
        </div>
    </div>
</template>
<script>
export default {
    props : {
        title : {
            type : String,
            required : true
        },
        index : {
            type : Number,
            required : true
        },
        maxIndex : {
            type : Number,
            required : true
        },
        rightOption : {
            type : Boolean,
            required : true,
            default : false
        },
        rightTitle : {
            type : String,
            required : true
        }
    },
    data: function(){
        return{
            colors: JSON.parse(localStorage.getItem("colors"))
        }
    },
    methods : {
        calcCircle(index){
            if(index > this.index){
                return ''
            }

            return 'circle-white'
        },
        exit(){
            this.$router.push('/dashboard')
        }
    }
}
</script>
<style lang="scss" scoped>
    .slide-header{
        height: 70px;
        width: 100%;
        // background-color: #3defe4;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .slide-index{
            font-size: 10px;
            font-weight: bold;
        }

        .slide-title{
            position: relative;

            .title{
                font-weight: bold;
                font-size: 15px;
                text-transform: uppercase;
                letter-spacing: 1px;
                vertical-align: text-bottom;
            }

            .index-circle{
                display: flex;
                justify-content: center;
                position: absolute;
                top: 113%;
                left: calc(50% - 15px);

                .circle{
                    width: 5px;
                    height: 5px;
                    background-color: #ffffff33;
                    border-radius: 50px;
                    margin: 0 3px;
                }

                .circle-white{
                    background-color : white;
                }
            }
        }

        .slide-right-option{

            cursor: pointer;

            .right-option{
                max-width: 32px;
                // color: white;
                border: 1px solid;
                padding: 5px 20px;
                border-radius: 20px;    
                text-transform: uppercase;
                font-size: 10px;
                font-weight: bold;
            }
        }
    }
</style>
